<template>
  <div class="scroll_flex_container">
    <!-- <div ref="processBar" style="width: 100%"> -->
    <Process></Process>
    <!-- </div> -->
    <Ordering v-if="getUrlParameters.process === 'ordering' && googleSheetId"></Ordering>
    <OrderConfirm
      v-else-if="getUrlParameters.process === 'orderConfirm' && googleSheetId"
    ></OrderConfirm>
  </div>
</template>
<script>
import process from "@/components/store/process.vue";
import Ordering from "@/views/store/Ordering.vue";
import OrderConfirm from "@/views/store/OrderConfirm.vue";
import { mapState } from "vuex";
export default {
  components: {
    Process: process,
    Ordering: Ordering,
    OrderConfirm: OrderConfirm,
  },
  data() {
    return {
    };
  },
  beforeMount() {
    //TODO: 改成使用 cart module
    // const storeData = commonUtilities.getLocalStorageItem(this.currentStore)
    // if (storeData?.cart) {
    //   this.$store.dispatch("cart/setCart", storeData.cart)
    // }
  },
  computed: {
    ...mapState("basic", {
      currentStore: "currentStore",
    }),
    googleSheetId() {
      return this.$store.getters['basic/googleSheetId']
    },
    getUrlParameters() {
      return this.$route.params
    },
  },
  methods: {
  },
  beforeRouteEnter(to, from, next) {
    if (from.params.process === "orderPayment" && to.name !== 'ordering') {
      console.log("從訂單付款頁面離開", to, from);
      next({ path: `/${to.params.store}/store` })
    } else {
      next();
    }
  },
};
</script>
<style lang="scss">
.categories {
  font-size: 18px;
  font-family: PingFang SC;
  font-size: 500;
  -ms-overflow-style: none;
  /* IE and Edge */
  scrollbar-width: none;
  /* Firefox */
  width: 100%;
  padding: 5px 3%;
  flex-shrink: 0;
  overflow-x: auto;
  background-color: #fff;
  box-shadow: -1px 0px 6px 6px rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: -1px 0px 6px 6px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: -1px 0px 6px 6px rgba(0, 0, 0, 0.1);
}

.categories::-webkit-scrollbar {
  display: none;
}

.categories div {
  padding: 12px;
  cursor: pointer;
  border-radius: 10px;
  white-space: nowrap;
}

.categories div.active {
  background-color: #fd5001;
  color: #fff;
}

.products {
  overflow-y: auto;
  flex-grow: 1;
  width: 100%;
  padding: 0 7% calc(100px + env(safe-area-inset-bottom));
  background-color: #fff;
}

.product {
  width: 100%;
  padding: 10px 0;
  border-bottom: 1px dotted #000;
  flex-shrink: 0;
  margin-bottom: 15px;
}
</style>
